// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".page_8fcjn{width:100%}.page__body_ipxpL{padding:16px}.search_-F5Ai{background:#141e2b;position:sticky;top:48px;padding:10px 0;z-index:1}@media(min-width: 768px){.search_-F5Ai{top:78px}}.products_YYgFP{display:grid;grid-template-columns:1fr;grid-gap:8px;margin-top:24px}@media(min-width: 768px){.products_YYgFP{grid-template-columns:1fr 1fr 1fr}}@media(min-width: 1300px){.products_YYgFP{grid-template-columns:1fr 1fr 1fr 1fr 1fr;grid-gap:12px}}.pagination_TnDxh{margin:40px 0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": "page_8fcjn",
	"page__body": "page__body_ipxpL",
	"search": "search_-F5Ai",
	"products": "products_YYgFP",
	"pagination": "pagination_TnDxh"
};
module.exports = ___CSS_LOADER_EXPORT___;
